'use strict';

import systemVariables from '@/assets/js/api/functions';

export default {
    namespaced: true,
    state: {
        systemVariablesList: [],
        systemVariablesDetails: {}
    },
    getters: {
        getSystemVariablesList: (state) => state.systemVariablesList,
        getSystemVariablesDetails: (state) => state.systemVariablesDetails
    },
    mutations: {
        SET_SYSTEM_VARIABLES_LIST(state, payload) {
            state.systemVariablesList = payload;
        },
        SET_SYSTEM_VARIABLES_DETAILS(state, payload) {
            state.systemVariablesDetails = payload;
        },
        CLEAR_STATE(state) {
            state.systemVariablesList = [];
            state.systemVariablesDetails = {};
        }
    },
    actions: {
        fetchSystemVariables(context, payload) {
            let { config } = payload || {};
            return new Promise((resolve, reject) => {
                systemVariables
                    .getData({ to: '/cms-variables', config })
                    .then((response) => {
                        // console.log(response);

                        Object.values(response.data).map((key, index) => {
                            response.data[index].full_name = [key.first_name, key.last_name].filter(Boolean).join(' ');
                            response.data[index].active_status = key.status == 'ACTIVE' ? true : false;
                        });
                        context.commit('SET_SYSTEM_VARIABLES_LIST', response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.commit('SET_SYSTEM_VARIABLES_LIST', []);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        findSystemVariable(context, payload) {
            let { id, config } = payload || {};
            return new Promise((resolve, reject) => {
                systemVariables
                    .getData({ to: `/cms-variables/${id}`, config })
                    .then((response) => {
                        // console.log(response);
                        context.commit('SET_SYSTEM_VARIABLES_DETAILS', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.commit('SET_SYSTEM_VARIABLES_DETAILS', {});
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        addSystemVariable(context, payload) {
            let { data, config } = payload || {};
            return new Promise((resolve, reject) => {
                systemVariables
                    .postData({ to: '/cms-variables', data, config })
                    .then((response) => {
                        // console.log(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        setSystemVariable(context, payload) {
            let { data, config } = payload || {};
            return new Promise((resolve, reject) => {
                systemVariables
                    .putData({ to: '/cms-variables', data, config })
                    .then((response) => {
                        // console.log(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        deleteSystemVariable(context, payload) {
            let { config } = payload || {};
            return new Promise((resolve, reject) => {
                systemVariables
                    .deleteData({ to: '/cms-variables', config })
                    .then((response) => {
                        // console.log(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        }
    }
};
